export default {
    dashboard: {
        totalWordsGenerated: 'Insgesamt generierte Wörter',
        wordsPerDay: 'Wörter/Tag',
        content: 'Inhalt',
        date: 'Datum',
        variationCount: 'Anzahl der Variationen',
        transactionId: 'Transaktions-ID',
        totalWordsCount: 'Gesamtwortzahl',
        action: 'Aktion',
        goTo: 'Gehe zu',
        viewMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        tabImage: 'Bild',
        tabText: 'Text',
        dashboardSubtitle: 'Verwalten Sie Ihren KI-generierten Inhalt',
        type: 'Typ',
    },
};
